import { useEffect, useState } from 'react'
import { pdfjs } from 'react-pdf'

// Configure the worker to use the local version from node_modules
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

/**
 * Hook that gets the total number of pages in a PDF
 */
export function usePdfPageCount(pdfUrl: string | undefined): {
  pageCount: number
  isLoading: boolean
} {
  const [pageCount, setPageCount] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let mounted = true

    if (!pdfUrl) {
      setPageCount(0)
      setIsLoading(false)
      return
    }

    setIsLoading(true)

    async function getPageCount() {
      try {
        const loadingTask = pdfjs.getDocument({
          url: pdfUrl,
          verbosity: 0, // Suppress warnings for malformed PDFs
        })
        const pdf = await loadingTask.promise

        if (mounted) {
          setPageCount(pdf.numPages)
          setIsLoading(false)
        }
      } catch (error) {
        console.error('Error getting PDF page count:', error)
        if (mounted) {
          setPageCount(0)
          setIsLoading(false)
        }
      }
    }

    getPageCount()

    return () => {
      mounted = false
    }
  }, [pdfUrl])

  return { pageCount, isLoading }
}
